// extracted by mini-css-extract-plugin
module.exports = {"title-highlighted":"_93444fe79c--title-highlighted--WULUI","subtitle":"_93444fe79c--subtitle--vHiOV"};